define('app/router',['require','common/baseRouter'],function(require) {
	'use strict';

	var BaseRouter = require('common/baseRouter'),
		appRoutes = {
			'': 'dashboard',
			'index.html': 'dashboard',
			'dashboard': 'dashboard',
			'dashboard/:dashboardId': 'dashboard',
			'domains/:domainId/new-report': 'newReport',
			'domains/:domainId/dashboards/:dashboardId/type/:type/new-report': 'newReport',
			'domains/:domainId/dashboards/:dashboardId/new-monitor': 'newMonitor',
			'domains/:domainId/reports/:id/filtered': 'reportFiltered',
			'domains/:domainId/reports/:id': 'report',
			'domains/:domainId/segments/:id': 'segment',
			'domains/:domainId/monitors/:id': 'monitor',
			'domains/:domainId/unsaved-report/:id': 'unsavedReport',
			'domains/:domainId/unsaved-monitor/:id': 'unsavedMonitor',
			'logout': 'logout'
		},
		AppRouter = BaseRouter.extend({
			appRoutes: appRoutes,
			keyBindings: {}
		});

	//export the hash so we can use it without instantiating an instance of AppRouter
	AppRouter.appRoutes = appRoutes;

	return AppRouter;
});

